import { render } from "./PinGroup.vue?vue&type=template&id=4325b7dd&scoped=true"
import script from "./PinGroup.vue?vue&type=script&lang=js"
export * from "./PinGroup.vue?vue&type=script&lang=js"

import "./PinGroup.vue?vue&type=style&index=0&id=4325b7dd&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4325b7dd"]])

export default __exports__